import React from "react";
import { useTranslation } from "react-i18next";

export default function DownloadEndpointFiles() {
  const { t } = useTranslation("help");

  const pythonCode = `import requests

API_KEY = ""  # ${t("DownloadEndpointFiles.required", "Required")}
SESSION_KEY = ""  # ${t("DownloadEndpointFiles.required", "Required")}
ENDPOINT_ID = ""  # ${t("DownloadEndpointFiles.required", "Required")}

url = f"https://demo.whitehax.com/api/endpoint-files/download/{ENDPOINT_ID}"

headers = {"Authorization": API_KEY, "X-Session-Key": SESSION_KEY}

response = requests.request("GET", url, headers=headers)

response.raise_for_status()

output_path = f"endpoint_files_{ENDPOINT_ID}.zip"
with open(output_path, "wb") as f:
    f.write(response.content)`;

  return (
    <div className="endpoint-container">
      <a href="#download-endpoint-files" className="endpoint-title">
        {t("DownloadEndpointFiles.title", "Download Endpoint Files")}
      </a>

      <pre className="code-block">
        <code>{pythonCode}</code>
      </pre>

      <style>{`
        .endpoint-container {
          width: 100%;
          box-sizing: border-box;
          background: #1f1f1f;
          color: #f5f5f5;
          padding: 20px;
          font-family: Arial, Helvetica, sans-serif;
        }

        .endpoint-title {
          display: inline-block;
          margin-bottom: 26px;
          color: #fff;
          font-size: 16px;
          font-weight: 600;
          text-decoration: underline;
          cursor: pointer;
        }

        .endpoint-title:hover {
          color: #b7ddf2;
        }

        .code-block {
          margin: 0;
          padding: 0;
          background: transparent;
          color: #d4d4d4;
          font-family: Consolas, "Courier New", monospace;
          font-size: 14px;
          line-height: 1.45;
          white-space: pre-wrap;
          overflow-x: auto;
          tab-size: 4;
        }

        .code-block code {
          font-family: inherit;
        }

        @media (max-width: 768px) {
          .endpoint-title {
            font-size: 15px;
            margin-bottom: 20px;
          }

          .code-block {
            font-size: 13px;
            line-height: 1.45;
          }
        }
      `}</style>
    </div>
  );
}